import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'

const Icon = () => {
  return (
    <PictureAsPdfOutlinedIcon
      htmlColor='#E62E30'
      fontSize='large'
    />
  )
}

export default Icon
